import React from "react";
import styles from "./Offer.module.css";

export default function Offer() {
    return (
        <div className={styles.page}>
            <div className={styles.wrap}>
                <h1 className={styles.title}>Публичная оферта</h1>
                <button
                    className={styles.back}
                    onClick={() => (window.location.href = "/")}
                >
                    ← На главную
                </button>

                <article className={styles.sheet}>
                <div className={styles.card}>
                    <p className={styles.text}>
                        Дата вступления в силу: 11 сентября 2025 г.
                    </p>
                </div>

                <div className={styles.card}>
                    <p className={styles.text}>
                        Индивидуальный предприниматель Слешин Алексей Кириллович, действующий на основании
                        Свидетельства о государственной регистрации № 324774600362542 от 03.06.2024,
                        именуемый в дальнейшем «Исполнитель», с одной стороны, и любое физическое или юридическое лицо,
                        надлежащим образом принявшее настоящее предложение («Пользователь»), вместе именуемые «Стороны»,
                        заключили настоящий договор (далее – «Договор») о нижеследующем.
                    </p>
                </div>

                {/* 1 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>1. Термины и определения</h2>

                    <p className={styles.text}>
                        Сайт/Сервис — веб-сайт Исполнителя https://aimir.tech, предоставляющий функционал для
                        автоматизированной проверки документов с использованием технологий искусственного интеллекта.
                        <br />
                        Услуга — предоставление Пользователю доступа к функционалу Сайта на условиях подписки согласно
                        выбранному тарифному плану.
                        <br />
                        Подписка — модель оплаты, при которой доступ предоставляется на определённый срок.
                        <br />
                        Тарифный план — описание объёма функционала и его стоимости.
                        <br />
                        Аккаунт — уникальная учётная запись Пользователя.
                        <br />
                        Контент — материалы, загружаемые Пользователем в Сервис.
                    </p>
                </section>

                {/* 2 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>2. Предмет договора</h2>

                    <p className={styles.text}>
                        Исполнитель предоставляет Пользователю доступ к Сервису на условиях подписки,
                        а Пользователь обязуется оплатить стоимость тарифа.
                        <br />
                        Услуги оказываются дистанционно. Результат — доступ к Аккаунту и отчёт по анализу Контента.
                        <br />
                        Сервис не является юридической консультацией и не несёт ответственности за решения
                        Пользователя.
                    </p>
                </section>

                {/* 3 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>3. Момент заключения договора и регистрация</h2>

                    <p className={styles.text}>
                        Настоящий текст является публичной офертой (ст. 435, 437 ГК РФ).
                        <br />
                        Акцепт оферты — регистрация на Сайте либо оплата тарифа.
                        <br />
                        Совершая указанные действия, Пользователь подтверждает согласие с условиями.
                        <br />
                        Регистрация возможна через e-mail.
                        <br />
                        Заказ считается оформленным после поступления средств на счёт Исполнителя.
                    </p>
                </section>

                {/* 4 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>4. Права и обязанности сторон</h2>

                    <h3 className={styles.h3}>Исполнитель обязуется:</h3>
                    <p className={styles.text}>
                        — Предоставить доступ к Сервису согласно выбранному тарифу.<br />
                        — Обеспечивать работоспособность Сервиса (кроме профилактики).<br />
                        — Сохранять конфиденциальность данных Пользователя.
                    </p>

                    <h3 className={styles.h3}>Исполнитель вправе:</h3>
                    <p className={styles.text}>
                        — Изменять стоимость тарифов и условия, уведомляя за 10 дней публикацией на Сайте.<br />
                        — Блокировать или удалять Аккаунт при нарушениях.<br />
                        — Прекратить оказание услуг при неоплате Подписки.
                    </p>

                    <h3 className={styles.h3}>Пользователь обязуется:</h3>
                    <p className={styles.text}>
                        — Использовать Сервис законно.<br />
                        — Не загружать незаконный или вредоносный Контент.<br />
                        — Не пытаться взломать или нарушать безопасность.<br />
                        — Не передавать учётные данные третьим лицам.<br />
                        — Своевременно оплачивать тариф.
                    </p>

                    <h3 className={styles.h3}>Пользователь вправе:</h3>
                    <p className={styles.text}>
                        — Требовать оказания услуг в соответствии с Договором.<br />
                        — Отказаться от услуг, удалив свой Аккаунт.
                    </p>
                </section>

                {/* 5 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>5. Стоимость услуг и порядок расчётов</h2>

                    <p className={styles.text}>
                        Стоимость определяется тарифом на Сайте.
                        <br />
                        Оплата — 100 % предоплата за период подписки.
                        <br />
                        Оплата производится безналично через эквайринг или иные способы.
                    </p>
                </section>

                {/* 6 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>6. Порядок возврата</h2>

                    <p className={styles.text}>
                        Услуга потребляется с момента предоставления доступа и не подлежит возврату
                        (ст. 782 ГК РФ).
                        <br />
                        Возврат возможен только при невозможности использования услуги по вине Исполнителя.
                    </p>
                </section>

                {/* 7 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>7. Ответственность и разрешение споров</h2>

                    <p className={styles.text}>
                        Стороны несут ответственность по законодательству РФ.
                        <br />
                        Исполнитель не отвечает за убытки, вызванные использованием Сервиса.
                        <br />
                        Исполнитель не отвечает за Контент Пользователя.
                        <br />
                        Споры решаются переговорами, затем — в суде по месту регистрации Исполнителя.
                        <br />
                        Претензии направляются по адресу: 125171, Россия, г. Москва, проезд 5-й Войковский, д. 2,
                        кв. 37 или на e-mail: strong.2026@list.ru. Срок рассмотрения — 30 дней.
                    </p>
                </section>

                {/* 8 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>8. Прочие условия</h2>

                    <p className={styles.text}>
                        Договор вступает в силу с момента акцепта и действует до исполнения обязательств.
                        <br />
                        Исполнитель вправе прекратить Договор при существенном нарушении Пользователем условий.
                        <br />
                        Неурегулированные вопросы решаются по законодательству РФ.
                    </p>
                </section>

                {/* 9 */}
                <section className={styles.card}>
                    <h2 className={styles.h2}>9. Реквизиты Исполнителя</h2>

                    <p className={styles.text}>
                        Индивидуальный предприниматель: СЛЕШИН АЛЕКСЕЙ КИРИЛЛОВИЧ<br />
                        Юридический адрес: 125171, Россия, г. Москва, проезд 5-й Войковский, д. 2, кв. 37<br />
                        Почтовый адрес: strong.2026@list.ru<br />
                        ИНН: 774335676546<br />
                        ОГРНИП: 324774600362542<br />
                        Р/с: 40802810500006291989<br />
                        Банк: АО «ТБанк»<br />
                        БИК: 044525974<br />
                        Корр. счёт: 30101810145250000974<br />
                        Телефон: 8 (995) 300-38-86<br />
                        E-mail: strong.2026@list.ru
                    </p>

                    <p className={styles.update}>
                        Последнее обновление: 11.09.2025
                    </p>
                </section>
                </article>
            </div>
        </div>
    );
}
